// extracted by mini-css-extract-plugin
export default {"readOnly":"oHNwbV","disabled":"U1XPip"};